// extracted by mini-css-extract-plugin
module.exports = {"discount_wrapper":"_927a99ad28--discount_wrapper--WvwbV","price_without_discount":"_927a99ad28--price_without_discount--USxCv"};